import dayGridPlugin from "@fullcalendar/daygrid";
import interactionPlugin from "@fullcalendar/interaction";
import resourceTimelineDay from "@fullcalendar/resource-timeline";
// import resourceTimeGridPlugin from "@fullcalendar/resource-timegrid";
import timeGridPlugin from "@fullcalendar/timegrid";
import moment from "moment";
const scrollTime = moment().format("HH") + ":00:00";
const commonConfig = {
  nowIndicator: true,
  aspectRatio: 2.4,
  resourceAreaWidth: "230px",
  slotMinWidth: "70",
  eventMinWidth: "70",
  eventMinHeight: "25",
  eventShortHeight: "100",
  defaultTimedEventDuration: "00:30:00",
  forceEventDuration: true,
  slotEventOverlap: false,
  droppable: true,
  editable: true,
  selectable: true,
  selectMirror: false,
  dayMaxEvents: true,
  weekends: true,
  events: [],
  resources: [],
  plugins: [
    dayGridPlugin,
    interactionPlugin,
    resourceTimelineDay,
    timeGridPlugin,
  ],
  schedulerLicenseKey: "CC-Attribution-NonCommercial-NoDerivatives",
  dateClick: null,
  eventDrop: null,
  eventClick: null,
  eventMouseEnter: null,
  eventMouseLeave: null,
  drop: null,
  eventDragStart: null,
  eventDragStop: null,
  dropAccept: ".drop-event",
  customButtons: null,
  scrollTime,
};
export function config() {
  return {
    ...commonConfig,
    buttonText: {
      today: "Today",
      year: "Year",
      month: "Month",
      week: "Week",
      day: "Day",
      list: "List",
    },
    headerToolbar: {
      left: "today",
      center: "prev title next",
      right: "resourceTimelineDay,resourceTimelineWeek",
    },
    initialView: "resourceTimelineDay", // timeGridDay //resourceTimelineDay
    resourceGroupField: "building",
    resourceGroupLabelContent: function ({ groupValue }) {
      return {
        html: `<span class="fc-datagrid-cell-main" title="${groupValue}">${groupValue}</span>`,
      };
    },
    resourceLabelContent: function ({ fieldValue, resource }) {
      const { siteId, userId, startDate } = resource._resource.extendedProps;
      const href = `#/scheduler-single/${siteId}/${userId}`;
      const maxLength = 18;
      const trimmed =
        fieldValue.length > maxLength
          ? fieldValue.substring(0, maxLength) + "..."
          : fieldValue;

      return {
        html: `
      <span class="mb-0" title="${fieldValue}">
        ${trimmed}
        <a class="float-end ms-3" href="${href}">
          <i class="las la-calendar-alt fs-1"></i>
        </a>
      </span>
    `,
      };
    },
    eventContent: function ({ event }) {
      const displayTime = `${moment(event._def.extendedProps?.startDate).format(
        "h:mmA"
      )} - ${moment(event._def.extendedProps?.endDate).format("h:mmA")}`;
      return {
        html: `<p class='mb-0 fw-bolder text-truncate'>${event._def.title}</p><span style="display:block" class="text-truncate">${displayTime}</span>`,
      };
    },
  };
}
export function configDay() {
  // .subtract(1, "millisecond")
  const date = moment().add(2, "day").format("YYYY-MM-DD"); // add two days to current date
  return {
    ...commonConfig,
    headerToolbar: {
      left: "today",
      center: "prev title next",
      right: "",
    },
    allDaySlot: false,
    initialView: "timeGridDay", // timeGridDay //resourceTimelineDay
    eventContent: function ({ event }) {
      const displayTime = `${moment(event._def.extendedProps?.startDate).format(
        "h:mmA"
      )} - ${moment(event._def.extendedProps?.endDate).format("h:mmA")}`;
      return {
        html: `<p class='mb-0 fw-bolder text-truncate'>${event._def.title} ${displayTime}</p>`,
      };
    },
  };
}
